import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Devices: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Devices">
      <path
        id="Vector"
        d="M6 7.50044V7.20044C6 6.08033 6 5.51986 6.21799 5.09204C6.40973 4.71572 6.71547 4.40998 7.0918 4.21823C7.51962 4.00024 8.08009 4.00024 9.2002 4.00024H17.8002C18.9203 4.00024 19.4796 4.00024 19.9074 4.21823C20.2837 4.40998 20.5905 4.71572 20.7822 5.09204C21 5.51945 21 6.07924 21 7.19715V13.8033C21 14.9212 21 15.4802 20.7822 15.9076C20.5905 16.284 20.2839 16.5907 19.9076 16.7825C19.4802 17.0002 18.921 17.0002 17.8031 17.0002H10.5M3 16.8004V11.2004C3 10.0803 3 9.51986 3.21799 9.09204C3.40973 8.71572 3.71547 8.40998 4.0918 8.21823C4.51962 8.00024 5.08009 8.00024 6.2002 8.00024H6.80019C7.9203 8.00024 8.47957 8.00024 8.9074 8.21823C9.28372 8.40998 9.59048 8.71572 9.78223 9.09204C10 9.51944 10 10.0792 10 11.1972V16.8033C10 17.9212 10 18.4802 9.78223 18.9076C9.59048 19.284 9.28372 19.5907 8.9074 19.7825C8.47999 20.0002 7.921 20.0002 6.80309 20.0002H6.19691C5.07899 20.0002 4.5192 20.0002 4.0918 19.7825C3.71547 19.5907 3.40973 19.284 3.21799 18.9076C3 18.4798 3 17.9205 3 16.8004Z"
        stroke="currentColor"
        strokeWidth="currentStrokWidth"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Devices;
